'use client';

import { FC, PropsWithChildren, useLayoutEffect, useRef } from 'react';
import { HideScrollProps } from './types';

import styles from './HideOnScroll.module.scss';

export const HideOnScroll: FC<PropsWithChildren<HideScrollProps>> = ({
  offset = 0,
  children
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const childRef = useRef<HTMLDivElement>(null);
  const isVisible = useRef(true);

  useLayoutEffect(() => {
    const scrollHandler = () => {
      const node = ref.current;
      if (!node) return;

      const originalHeight = childRef.current?.clientHeight ?? 0;
      if (window.scrollY > offset && isVisible.current) {
        isVisible.current = false;

        // Set initial height first to get the right animation
        node.style.height = `${originalHeight}px`;
        setTimeout(() => {
          node.style.height = '0px';
        }, 20);
      } else if (!isVisible.current) {
        isVisible.current = true;
        node.style.height = `${originalHeight}px`;
      }
    };

    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [offset]);

  return (
    <div ref={ref} className={styles['hidden']}>
      <div ref={childRef}>{children}</div>
    </div>
  );
};
